















































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ResetRequestPwdBox extends Vue
{
    @Prop() token!: string;
    email: string = '';
    password: string = '';
    confirm_password: string = '';
    error: string | null = null;
    message: string = '';
    loading: boolean = false;

    async reset_password(): Promise< void >
    {
        try
        {
            if( this.password !== this.confirm_password )
            {
                this.error = 'Le password non coincidono';
                return;
            }
            this.loading = true;
            let data = new FormData;
            data.append( 'email', this.email );
            data.append( 'token', this.token );
            data.append( 'password', this.password );
            const response = await this.$http.post( '/auth/reset-password', data );
            this.message = 'Il reset della password è stato effettuato. Adesso è possibile effettuare l\'accesso';
        }
        catch( error )
        {
            this.error = 'Si è verificato un errore. Si prega di riprovare';
        }
        this.loading = false;
    }
}
